import React from 'react';
import { CLASSNAME } from '@skin-seoul/service';
import shieldIcon from './assets/shield.png';
import packageIcon from './assets/package.png';
import { resolveImageSrc } from '../../../utils';

export function CartTrustBadges() {
  return (
    <div className="flex gap-2 items-center justify-center w-full flex-wrap py-2">
      <div className="flex items-center gap-2 bg-primary-50 rounded-[36px] pl-3 pr-4 py-1">
        <img src={resolveImageSrc(shieldIcon)} alt="Authenticity Guarantee" className="w-6 h-6 shrink-0" />
        <span className={`text-label-small font-medium text-neutral-800 ${CLASSNAME.NOT_TRANSLATE}`}>
          Authenticity Guarantee
        </span>
      </div>
      <div className="flex items-center gap-2 bg-primary-50 rounded-[36px] pl-3 pr-4 py-1">
        <img src={resolveImageSrc(packageIcon)} alt="Easy Returns" className="w-6 h-6 shrink-0" />
        <span className={`text-label-small font-medium text-neutral-800 ${CLASSNAME.NOT_TRANSLATE}`}>Easy Returns</span>
      </div>
    </div>
  );
}
